let API_URL = process.env.REACT_APP_API_URL;

if (typeof API_URL === 'string' && API_URL.length) {
  API_URL = API_URL.replace(/\/$/, '');
}

export {API_URL};

// API Endpoints
// Account
export const ENDPOINT_LOGIN = `${API_URL}/v1/login`;
export const ENDPOINT_REFRESH = `${API_URL}/v1/login/refresh`;
export const ENDPOINT_LOGOUT = `${API_URL}/v1/logout`;
export const ENDPOINT_FORGOT = `${API_URL}/v1/users/passwords`;
export const ENDPOINT_USER_PROFILE = `${API_URL}/v1/profile`;
export const ENDPOINT_ACCOUNT_VERIFY = `${API_URL}/v1/account/verify/`;
export const ENDPOINT_RESEND_VERIFY = `${API_URL}/v1/account/verify/resend-validation`;
export const ENDPOINT_PUSH_SUBSCRIPTIONS = `${API_URL}/v1/admin/push-subscriptions`;

// Order Management
export const ENDPOINT_CLIENT_ORDERS = `${API_URL}/v1/client/orders/{order}`;
export const ENDPOINT_CLIENT_USER_ORDERS = `${API_URL}/v1/client/orders/user/{user}`;
export const ENDPOINT_CLIENT_ORDER_RESEND_INVOICE = `${API_URL}/v1/client/orders/{order}/resend-invoice`;
export const ENDPOINT_GET_REFUND_ORDER_DATA = `${API_URL}/v1/client/orders/{orderId}/refund/initiate`;
export const ENDPOINT_REFUND_ORDER = `${API_URL}/v1/client/orders/{orderId}/refund/confirm`;
export const ENDPOINT_CANCEL_REFUND_ORDER = `${API_URL}/v1/client/orders/{orderId}/refund/cancel`;
export const ENDPOINT_ORDER_DOWNLOAD = `${API_URL}/v1/client/orders/{order}/download`;

export const ENDPOINT_ORDER_CANCEL = `${API_URL}/v1/client/orders/{order}/cancel`;

// Campaigns Management
export const ENDPOINT_CLIENT_CAMPAIGNS = `${API_URL}/v1/client/campaigns/{campaign}`;

// Coupons Management
export const ENDPOINT_CLIENT_COUPONS = `${API_URL}/v1/client/campaigns/{campaign}/coupons/{coupon}`;
export const ENDPOINT_CLIENT_GET_COUPONS = `${API_URL}/v1/client/coupons/{coupon}`;

// Organization
export const ENDPOINT_ORGANIZATION_USERS = `${API_URL}/v1/organizations/{organization}/users/{user}`;
export const ENDPOINT_ORGANIZATION_DETAILS = `${API_URL}/v1/client/organizations/{organization}`;

// Clients
export const ENDPOINT_CLIENTS = `${API_URL}/v1/client/users/{user}`;
export const ENDPOINT_CLIENTS_FORGOT = `${API_URL}/v1/client/users/passwords`;

// Admin Users
export const ENDPOINT_ADMIN_USERS = `${API_URL}/v1/admin/users/{user}`;
export const ENDPOINT_VERIFY_ADMIN = `${API_URL}/v1/account/verify/{id}/{hash}`;
export const ENDPOINT_ADMIN_GROUPS = `${API_URL}/v1/admin/groups/{group}`;
export const ENDPOINT_ADMIN_GROUPS_ACLS = `${API_URL}/v1/admin/groups/{group}/acls`;
export const ENDPOINT_ADMIN_ACLS = `${API_URL}/v1/admin/acls`;

// Documents
export const ENDPOINT_DOCUMENTS = `${API_URL}/v1/client/documents/{document}`;

//Certificates
export const ENDPOINT_CERTIFICATES = `${API_URL}/v1/client/certificates/{certificate}`
export const ENDPOINT_CERTIFICATES_RECOVER = `${API_URL}/v1/client/certificates/{certificate}/recover`

// Packages
export const ENDPOINT_PACKAGES = `${API_URL}/v1/client/packages/{package}`;
export const ENDPOINT_PACKAGE_ELIGIBLE_OWNERS = `${API_URL}/v1/client/packages/{package}/eligible-owners`;
export const ENDPOINT_PACKAGE_TRANSFER_OWNER = `${API_URL}/v1/client/packages/{package}/transfer`;
export const ENDPOINT_PACKAGE_TRANSFER_GROUP = `${API_URL}/v1/client/packages/{package}/transfer-group`;
export const ENDPOINT_ORGANIZATION_PACKAGE_GROUPS = `${API_URL}/v1/client/organizations/{organization}/package-groups`;

// Organizations
export const ENDPOINT_ORGANIZATIONS = `${API_URL}/v1/client/organizations/`;
export const ENDPOINT_ORGANIZATIONS_EXPORT = `${API_URL}/v1/client/organizations/export`;
export const ENDPOINT_ORGANIZATIONS_EXPORT_OPTIONS = `${API_URL}/v1/client/organizations/export/options`;
export const ENDPOINT_USER_ORGANIZATIONS = `${API_URL}/v1/client/organizations/user/{user}`;
export const ENDPOINT_LOCAL_KIOSK_SETTINGS = `${API_URL}/v1/client/local-kiosk-settings/{organization}`;

// Product Groups
export const ENDPOINT_PRODUCT_GROUPS = `${API_URL}/v1/client/productGroups/`;

// Order reports
export const ENDPOINT_ORDER_REPORTS = `${API_URL}/v1/admin/reports/orders/`
export const ENDPOINT_INFO_CARDS = `${API_URL}/v1/admin/reports/infoCards/`
export const ENDPOINT_DASHBOARD_REPORT = `${API_URL}/v1/admin/reports/dashboard`
export const ENDPOINT_SALES_REPORT_SUMMARY = `${API_URL}/v1/admin/reports/sales/summary`
export const ENDPOINT_SALES_REPORT_PRODUCTS = `${API_URL}/v1/admin/reports/sales/products`
export const ENDPOINT_SALES_REPORT_PERIODS = `${API_URL}/v1/admin/reports/sales/periods`
export const ENDPOINT_SALES_REPORT_ORGANIZATIONS = `${API_URL}/v1/admin/reports/sales/organizations`
export const ENDPOINT_ORGANIZATION_SALES_REPORT_SUMMARY = `${API_URL}/v1/admin/organizations/{organization}/reports/sales/summary`
export const ENDPOINT_ORGANIZATION_SALES_REPORT_PRODUCTS = `${API_URL}/v1/admin/organizations/{organization}/reports/sales/products`
export const ENDPOINT_ORGANIZATION_SALES_REPORT_PERIODS = `${API_URL}/v1/admin/organizations/{organization}/reports/sales/periods`
export const ENDPOINT_ORGANIZATION_SALES_REPORT_ACTIVITY = `${API_URL}/v1/admin/organizations/{organization}/reports/sales/activity`

// Tickets
export const ENDPOINT_CLIENT_TICKETS = `${API_URL}/v1/client/tickets/{ticket}`;

// Emails
export const ENDPOINT_CLIENT_EMAILS = `${API_URL}/v1/client/emails/`;

// Appointments
export const ENDPOINT_APPOINTMENTS = `${API_URL}/v1/client/appointments`;

export const ENDPOINT_NEO_COUNTIES = `${API_URL}/v1/admin/neo/counties`;
export const ENDPOINT_NEO_CITIES = `${API_URL}/v1/admin/neo/cities`;

// Appointment holidays Management
export const ENDPOINT_APPOINTMENT_HOLIDAYS = `${API_URL}/v1/client/appointment-holidays/{appointmentHoliday}`;

export const ENDPOINT_ARCHIVE_SERVICE_SETTINGS = `${API_URL}/v1/client/archive-service-settings/{archiveServiceSetting}`;

// Email campaigns Management
export const ENDPOINT_CLIENT_EMAIL_CAMPAIGNS = `${API_URL}/v1/client/email-campaigns/{emailCampaign}`;
